// generated by genversion
export var version = '4.7.3';
//# sourceMappingURL=version.js.map